export default __webpack_public_path__ + "static/media/Icon_Sign_out_black.b2976179.svg";